/*
 * cart-total-sync.js
 * The cart-footer (subtotal / estimated total + checkout button) lives in a
 * SEPARATE section from the cart-items list, and the cart-items component only
 * re-renders its OWN section when a quantity changes or a line is removed.
 * Result: the items list updates but the estimated total in the footer goes stale.
 *
 * This theme's cart page uses the Dawn-style <cart-items> element, which signals
 * updates through a JS pub/sub ('cart-update'), NOT a DOM 'cart:update' event - so
 * the previous DOM-event listener never fired. To be robust across both systems we
 * primarily watch the cart-items section for ANY re-render with a MutationObserver,
 * then re-fetch just the footer section and swap it in.
 *
 * The footer's real wrapper id is qualified in a JSON template
 * (shopify-section-template--123__cart-footer), so we read it at runtime from
 * #main-cart-footer[data-id] rather than hardcoding it.
 */
(function () {
  if (window.__pottiesCartTotalSync) return;
  window.__pottiesCartTotalSync = true;

  var busy = false;
  var pending = false;
  var timer = null;

  function getFooter() {
    var inner = document.getElementById('main-cart-footer');
    if (!inner) return null;
    var sectionId = inner.getAttribute('data-id');
    if (!sectionId) return null;
    var wrapper = inner.closest('[id^="shopify-section"]') || document.getElementById('shopify-section-' + sectionId);
    if (!wrapper) return null;
    return { sectionId: sectionId, wrapper: wrapper };
  }

  async function sync() {
    var f = getFooter();
    if (!f) return;
    if (busy) { pending = true; return; }
    busy = true;
    try {
      var sep = location.search ? location.search + '&' : '?';
      var url = location.pathname + sep + 'sections=' + encodeURIComponent(f.sectionId);
      var res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (res.ok) {
        var data = await res.json();
        var html = data && data[f.sectionId];
        if (html != null && f.wrapper.innerHTML !== html) f.wrapper.innerHTML = html;
      }
    } catch (e) { /* leave existing total in place on failure */ }
    busy = false;
    if (pending) { pending = false; setTimeout(sync, 30); }
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 130); }

  function findItemsWrapper() {
    var byId = document.querySelector('[id^="shopify-section"][id*="cart-items"]');
    if (byId) return byId;
    var el = document.querySelector('cart-items, cart-items-component');
    return el ? el.closest('[id^="shopify-section"]') : null;
  }

  function init() {
    // Primary: re-render of the items list (works for Dawn pub/sub, which fires no DOM event).
    var items = findItemsWrapper();
    if (items) {
      new MutationObserver(schedule).observe(items, { childList: true, subtree: true });
    }
    // Secondary: DOM events, for any flow that does dispatch them.
    document.addEventListener('cart:update', schedule);
    document.addEventListener('cart:refresh', schedule);
    return !!items;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
